import moment from 'moment';

export const normalizeBlacklistValidUntil = (
  validUntil: moment.Moment | number | string | null | undefined
): number | undefined => {
  if (!validUntil) return undefined;
  if (typeof validUntil === 'number') return validUntil;
  const parsed = moment.isMoment(validUntil) ? validUntil.clone() : moment(validUntil);
  if (!parsed.isValid()) return undefined;
  return parsed.endOf('day').unix();
};
